/**
 * Copyright © PlanMaster Fogászati Szoftver Kft. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Tamas Neufeld <tamas.neufeld@planmaster3d.com>, 2018
 */

export function moveArrayItem(arr, oldIndex, newIndex) {
    while (oldIndex < 0) {
        oldIndex += arr.length;
    }
    while (newIndex < 0) {
        newIndex += arr.length;
    }
    if (newIndex >= arr.length) {
        let k = newIndex - arr.length;
        while ((k--) + 1) {
            arr.push(undefined);
        }
    }
    arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
    return arr; // for testing purposes
}

export function getArrayUnique(a) {
    let result = [];
    a.forEach(function(item) {
        if (result.indexOf(item) < 0) {
            result.push(item);
        }
    });
    return result;
}

export function getArrayIntersect(a, b) {
    let t;
    if (b.length > a.length) t = b, b = a, a = t; // indexOf to loop over shorter
    return a.filter(function(e) {
        return b.indexOf(e) > -1;
    }).filter(function(e, i, c) { // extra step to remove duplicates
        return c.indexOf(e) === i;
    });
}

export function getUnionOfArrays(x, y) {
    let obj = {};
    for (let i = x.length - 1; i >= 0; --i) {
        obj[x[i]] = x[i];
    }
    for (let i = y.length - 1; i >= 0; --i) {
        obj[y[i]] = y[i];
    }
    let res = [];
    for (let k in obj) {
        if (obj.hasOwnProperty(k))  // <-- optional
            res.push(obj[k]);
    }
    return res;
}

export function sortArrayByColumn(a, colIndex) {
    a.sort(sortFunction);
    function sortFunction(a, b) {
        if (a[colIndex] === b[colIndex]) {
            return 0;
        } else {
            return (a[colIndex] < b[colIndex]) ? -1 : 1;
        }
    }
    return a;
}
